module.exports = __webpack_public_path__ + "3e4f5c3b9c1328b6149bf8617b4fdc2f.jpg";